'use client';

import { handleQueryError } from '@/utils/someUtils';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactNode } from 'react';

export const TanstackProvider = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider
      client={
        new QueryClient({
          defaultOptions: {
            mutations: {
              onError: (error) => {
                handleQueryError(error);
              },
            },
            queries: {
              refetchOnWindowFocus: true,
              retry: 3,
              refetchOnMount: true,
            },
          },
          queryCache: new QueryCache({
            onError: handleQueryError,
          }),
        })
      }
    >
      {children}
    </QueryClientProvider>
  );
};
